'use client';

import React, { createContext, useContext, useState } from 'react';
import { getContainer } from '@framework/di/getContainer';

const useAccessRestricted = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [dataroomName, setDataroomName] = useState('');
  const [byCountry, setByCountry] = useState(false);

  const showAccessRestrictedModal = (dataroomName?: string, byCountry?: string) => {
    setIsModalVisible(true);
    !!dataroomName && setDataroomName(dataroomName);
    !!byCountry && setByCountry(byCountry === 'true');
  };

  const hideAccessRestrictedModal = () => {
    setIsModalVisible(false);
  };

  return {
    byCountry,
    dataroomName,
    isModalVisible,
    showAccessRestrictedModal,
    hideAccessRestrictedModal,
  };
};

export type AccessRestrictedContextType = ReturnType<typeof useAccessRestricted>;

const AccessRestrictedContext = createContext<AccessRestrictedContextType | null>(null);
export const AccessRestrictedContextSymbol = Symbol('AccessRestrictedContext');

export const useAccessRestrictedContext = () => {
  const context = useContext(AccessRestrictedContext);
  if (!context) {
    throw new Error('useAccessRestrictedContext must be used within a AccessRestrictedContextProvider');
  }
  return context;
};

interface IProps {
  children: React.ReactNode,
}

const AccessRestrictedContextProvider = ({ children }: IProps) => {
  const contextValue = useAccessRestricted();
  const container = getContainer();

  container.bindContextValue(AccessRestrictedContextSymbol, contextValue, true);

  return (
    <AccessRestrictedContext.Provider value={ contextValue }>
      { children }
    </AccessRestrictedContext.Provider>
  );
};

export default AccessRestrictedContextProvider;
